import ApiService from './api.service';

const PatientService = {

  getSurveyData: async () => {
    return ApiService.fetch('patient/survey');
  },

  getAll: () => ApiService.fetch('patients/all'),

  submitSurvey: async (surveyData) => {
    return ApiService.fetch('patient/survey', {
      method: 'POST',
      body: JSON.stringify(surveyData)
    });
  },

  updateProfile: (data) => ApiService.fetch('patient/profile', {
    method: 'PUT',
    body: JSON.stringify({
      first_name: data.first_name,
      last_name: data.last_name,
      birth_date: data.birth_date,
      fiscal_code: data.fiscal_code,
      gender: data.gender,
      address: data.address,
      phone: data.phone,
      medical_history: data.medical_history,
      pi: data.pi,       
    })
  }),

  updatePassword: (passwordData) => ApiService.fetch('patient/update-password', {
    method: 'POST',
    body: JSON.stringify(passwordData)
  }),

  getProfile: () => ApiService.fetch('patient/profile'),


};

export default PatientService;